export const linkTheme = {
  color: '--medkit-link-color',
  colorActive: '--medkit-link-color-active',
}
